@for (notif of notifs.slice().reverse(); track notif; let i = $index) {
    <div 
        class="notification d-flex no-print"
        [@notificationSlide]="{ value: 'in', params: { direction: direction } }"
        (click)="i === 0 ? 
                notif?.url ? 
                    urlRedirect() : 
                    dismissNotif() 
                : bringToFront(i)"
        [ngClass]="{
            'top': $safeNavigationMigration(notif.position?.includes('top')),
            'right': $safeNavigationMigration(notif.position?.includes('right')),
            'bottom': $safeNavigationMigration(notif.position?.includes('bottom')),
            'left': $safeNavigationMigration(notif.position?.includes('left')),
            'full-width': notif.position?.includes('left') && notif.position?.includes('right'),
            'full-height': notif.position?.includes('top') && notif.position?.includes('bottom'),
            'grab': i != 0
        }"
        [ngStyle]="{
            'z-index': NOTIF_Z_INDEX + notifs.length - i,
            'opacity': i === 0 ? 1 : OLD_NOTIF_OPACITY,
            'top': !notif.position?.includes('bottom') ? i * NOTIF_OFFSET + 'px' : 'auto',
            'bottom': notif.position?.includes('bottom') ? i * NOTIF_OFFSET + 'px' : 'auto',
        }"
    >
        <!-- Notification Icon -->
        <div class="icon d-flex justify-content-center align-items-center px-3 py-4" 
        [ngClass]="{
            'new-tab': notif.openNewTab && notif.url && i === 0,
            'redirect': !notif.openNewTab && notif.url && i === 0
        }"
        [ngStyle]="{
            'color': notif.iconColor,
            'backgroundColor': notif.iconBgColor
        }">
            <fa-icon [icon]="notif.iconDefinition ? notif.iconDefinition : defaultIcon"></fa-icon>    
        </div>

        <!-- Notification Body -->
        <div class="d-flex flex-column flex-fill"
        [ngStyle]="{    
            'background-image': notif.headerBgColor && notif.messageBgColor && 
            'linear-gradient(to bottom left,' + notif.headerBgColor + START_GRADIENT + ',' + notif.messageBgColor + END_GRADIENT + ')'}">
            <div class="d-flex justify-content-between pl-2"
            [ngClass]="{
                'new-tab': notif.openNewTab && notif.url && i === 0,
                'redirect': !notif.openNewTab && notif.url && i === 0
            }"
            [ngStyle]="{'backgroundColor': !notif.messageBgColor && notif.headerBgColor, 'color': notif.headerColor}">
                <span class="header">{{notif.header}}</span>
                <span class="time-sent ml-auto p-2">{{notif.timeSent | date: 'h:mm a'}}</span>
            </div>
            <div class="h-100 pl-2"        
            [ngStyle]="{'backgroundColor': !notif.headerBgColor && notif.messageBgColor, 'color': notif.messageColor}">
                @if(notif.html) {
                    <span class="message" [innerHTML]="notif.html" (click)="$event.stopPropagation()" ></span>
                } @else {
                    <span class="message" data-dd-privacy="mask"
                    [ngClass]="{
                        'new-tab': notif.openNewTab && notif.url && i === 0,
                        'redirect': !notif.openNewTab && notif.url && i === 0
                    }">{{notif.message}}</span>
                }            
            </div>
        </div>

        <!-- Dismiss Button -->
        <div>
            <button 
            [ngStyle]="{
                'color': notif.messageColor,
                'backgroundColor': notif.messageBgColor
            }"
            (click)="i === 0 ? dismissNotif() : bringToFront(i); $event.stopPropagation();"
            class="dismiss-btn btn btn-outline-dark ml-auto">
                <fa-icon [icon]="dismissIcon"></fa-icon>
            </button>
        </div>

        <!-- Timeout Progress Bar -->
        @if(i === 0) {
            <div 
                class="timeout-bar" 
                [ngStyle]="{'width.%': barWidth}"
            ></div>
        }
    </div>
}

